var Globals = {
  STATUS_BAR_HEIGHT : 0,
  ACTION_BAR_HEIGHT : 44,
  FEED_BOTTOM_SPACE_ADJUSTMENT : 0,//-30,
  FEED_TOP_SPACE_ADJUSTMENT : 0,//44,
  LAYOUT_HEIGHT_ADJUSTMENT : 0,
  TOP_LEFT_STYLE_ADJUSTMENT : {marginLeft:0},
  TOP_RIGHT_STYLE_ADJUSTMENT : {marginRight:0, flexDirection:'column' },
  TOP_RIGHT_INNER_STYLE_ADJUSTMENT : {height:28},
  TOP_CENTER_ADJUSTMENT : {},
  TOP_CENTER_TEXT_ADJUSTMENT : {flex:1},
  BANNER_ICON_ADJUSTMENT : {marginTop:0},
  TUTORIAL_ICON_STYLE : {},
  TAB_STYLE_ADJUSTMENT : {},
  TAB_BAR_HEIGHT: 50,
  addHardwareBackListener : function(callback)
  {
    // none existent on ios
  },
  removeHardwareBackListener : function(callback)
  {
    // none existent on ios
  }
}

module.exports = Globals;



// WEBPACK FOOTER //
// ./src/Globals.js